import React from "react";
import { Row, Col, Input, Button, Label } from "reactstrap";
import Switch from "react-switch";

export default function VenueOrganizer({ validation }) {

  const removeOrganizer = index => {
    const organizers = [...(validation.values.venue_organizer || [])];
    organizers.splice(index, 1);
    validation.setFieldValue("venue_organizer", organizers);
  };

  const handleAddOrganizer = () => {
    const organizers = validation.values.venue_organizer || [];

    const incomplete = organizers.some(
      (org) =>
        !org.organizer_name?.trim() ||
        !org.contact_number?.trim() ||
        !org.role?.trim() ||
        !org.email?.trim()
    );

    if (incomplete) {
      alert("Please fill all fields of existing organizers before adding a new one.");
      return;
    }

    validation.setFieldValue("venue_organizer", [
      ...organizers,
      { organizer_name: "", contact_number: "", role: "", email: "" },
    ]);
  };

  return (
    <>
      <div className="card border-0 shadow-sm p-3 mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <span className="fw-semibold">Enable Venue Organizers</span>

          <Switch
            checked={validation.values.enable_venue_organizer}
            onChange={(checked) =>
              validation.setFieldValue("enable_venue_organizer", checked)
            }
            onColor="#34c38f"
            offColor="#b3a692"
            height={16}
            width={32}
            handleDiameter={14}
            uncheckedIcon={false}
            checkedIcon={false}
          />
        </div>
      </div>

      {validation.values.enable_venue_organizer && (
        <div className="animate__animated animate__fadeIn">
          {(validation.values.venue_organizer || []).map((item, index) => (
            <div
              key={index}
              className="p-3 mb-2 rounded bg-light border d-flex align-items-center"
            >
              <Row className="g-2 align-items-center w-100">
                <Col md={3}>
                  <Label htmlFor="organizer_name"> Organizer Name </Label>
                  <Input
                    type="text"
                    placeholder="Organizer Name"
                    name={`venue_organizer[${index}].organizer_name`}
                    value={item.organizer_name}
                    onChange={validation.handleChange}
                  />
                  {validation.errors.venue_organizer?.[index]?.organizer_name && (
                    <div className="text-danger">
                      {validation.errors.venue_organizer[index].organizer_name}
                    </div>
                  )}
                </Col>

                <Col md={3}>
                  <Label htmlFor="contact_number"> Contact Number </Label>
                  <Input
                    type="text"
                    placeholder="Contact Number"
                    name={`venue_organizer[${index}].contact_number`}
                    value={item.contact_number}
                    onChange={validation.handleChange}
                  />
                  {validation.errors.venue_organizer?.[index]?.contact_number && (
                    <div className="text-danger">
                      {validation.errors.venue_organizer[index].contact_number}
                    </div>
                  )}
                </Col>

                <Col md={2}>
                  <Label htmlFor="role">Role</Label>
                  <Input
                    type="text"
                    placeholder="Role"
                    name={`venue_organizer[${index}].role`}
                    value={item.role}
                    onChange={validation.handleChange}
                  />
                  {validation.errors.venue_organizer?.[index]?.role && (
                    <div className="text-danger">
                      {validation.errors.venue_organizer[index].role}
                    </div>
                  )}
                </Col>

                <Col md={3}>
                  <Label htmlFor="email">Email ID</Label>
                  <Input
                    type="email"
                    placeholder="Email"
                    name={`venue_organizer[${index}].email`}
                    value={item.email}
                    onChange={validation.handleChange}
                  />
                  {validation.errors.venue_organizer?.[index]?.email && (
                    <div className="text-danger">
                      {validation.errors.venue_organizer[index].email}
                    </div>
                  )}
                </Col>

                <Col md={1} className="text-end">
                  <Button
                    color="link"
                    className="text-danger p-0"
                    onClick={() => removeOrganizer(index)}
                  >
                    <i className="mdi mdi-delete-outline fs-5"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}

          <Button color="outline-dark" size="sm" className="mt-2" onClick={handleAddOrganizer}>
            <i className="mdi mdi-plus-circle-outline me-1"></i> Add Organizer
          </Button>
        </div>
      )}
    </>
  );
}